export default __webpack_public_path__ + "static/media/img_work_profile@3x.88f7ccf9.png";